import React, { useMemo } from "react";

// ----------------------------------------------------------------------------

export default function AppText(props) {
  const {
    style,
    children,
    big,
    fin,
    small,
    xbig,
    xsmall,
    prod,
    bold,
    underline,
    noSpace,
  } = props;

  const fontFamily = useMemo(() => {
    if (bold) {
      return "HurmeBold";
    }
    return "HurmeLight";
  }, [bold]);

  const fontSize = useMemo(() => {
    if (xsmall) {
      return 11;
    }
    if (fin) {
      return 13;
    }
    if (prod) {
      return 20;
    }
    if (small) {
      return 16;
    }

    if (big) {
      return 30;
    }
    if (xbig) {
      return 40;
    }
    return 25;
  }, [small, big, xbig, xsmall, fin]);

  const lineHeight = useMemo(() => {
    if (xsmall) {
      return "16px";
    }
    if (fin) {
      return "13px";
    }
    if (small) {
      return bold ? "20px" : "19px";
    }
    if (big) {
      return "30px";
    }
    if (xbig) {
      return "40px";
    }

    return "25px";
  }, [small, big, xbig, xsmall]);

  return (
    <p
      style={{
        fontFamily: fontFamily,
        fontSize: fontSize,
        textDecoration: underline ? "underline" : null,

        lineHeight: lineHeight,
        // paddingRight: 10,
        ...style,
      }}
    >
      {children}
      {!noSpace && bold ? String.fromCharCode(160) : ""}
    </p>
  );
}

// ----------------------------------------------------------------------------
